// @ts-nocheck
import { Component } from 'react';
import { ApplyPluginsType } from 'umi';
import dva from 'dva';
// @ts-ignore
import createLoading from '/builds/oem/oem-fe-work-manager/node_modules/dva-loading/dist/index.esm.js';
import { plugin, history } from '../core/umiExports';
import ModelAuth0 from '/builds/oem/oem-fe-work-manager/src/models/auth.js';
import ModelBase1 from '/builds/oem/oem-fe-work-manager/src/models/base.js';
import ModelChannels2 from '/builds/oem/oem-fe-work-manager/src/models/channels.js';
import ModelCorpTags3 from '/builds/oem/oem-fe-work-manager/src/models/corp-tags.js';
import ModelDepartments4 from '/builds/oem/oem-fe-work-manager/src/models/departments.js';
import ModelGroup5 from '/builds/oem/oem-fe-work-manager/src/models/group.js';
import ModelMenu6 from '/builds/oem/oem-fe-work-manager/src/models/menu.js';
import ModelPublic7 from '/builds/oem/oem-fe-work-manager/src/models/public.js';
import ModelStore8 from '/builds/oem/oem-fe-work-manager/src/models/store.js';
import ModelUsers9 from '/builds/oem/oem-fe-work-manager/src/models/users.js';
import ModelAccount10 from '/builds/oem/oem-fe-work-manager/src/pages/company-management/ignore-routes/management/components/management/models/account.js';
import ModelCompanyManagement11 from '/builds/oem/oem-fe-work-manager/src/pages/company-management/ignore-routes/management/components/management/models/company-management.js';
import ModelAuth12 from '/builds/oem/oem-fe-work-manager/src/pages/company-management/models/auth.js';
import ModelBase13 from '/builds/oem/oem-fe-work-manager/src/pages/company-management/models/base.js';
import ModelPrograms14 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/authorization/work-weixin/models/programs.js';
import ModelCreateMoment15 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/company-moments/moments/models/create-moment.js';
import ModelMoments16 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/company-moments/moments/models/moments.js';
import ModelPostStat17 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/company-moments/moments/models/post-stat.js';
import ModelCustomField18 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/customer-management/models/custom-field.js';
import ModelDetails19 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/group-bulk/models/details.js';
import ModelGroupMsg20 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/group-bulk/models/group-msg.js';
import ModelDetails21 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/group-msg/models/details.js';
import ModelGroupMsg22 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/group-msg/models/group-msg.js';
import ModelBlock23 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/lost-customer/models/block.js';
import ModelDelete24 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/lost-customer/models/delete.js';
import ModelCharts25 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/stat-customer/models/charts.js';
import ModelStat26 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/stat-customer/models/stat.js';
import ModelCustomerInfo27 from '/builds/oem/oem-fe-work-manager/src/pages/crm/models/customer-info.js';
import ModelGrouping28 from '/builds/oem/oem-fe-work-manager/src/pages/crm/models/grouping.js';
import ModelMingChuang29 from '/builds/oem/oem-fe-work-manager/src/pages/crm/models/ming-chuang.js';
import ModelTags30 from '/builds/oem/oem-fe-work-manager/src/pages/crm/models/tags.js';
import ModelManage31 from '/builds/oem/oem-fe-work-manager/src/pages/message-control/ignore-routes/sensitive-behavior/models/manage.js';
import ModelRecord32 from '/builds/oem/oem-fe-work-manager/src/pages/message-control/ignore-routes/sensitive-behavior/models/record.js';
import ModelModel33 from '/builds/oem/oem-fe-work-manager/src/pages/app-self-support-order/ignore-routes/customer/model.js';
import ModelModel34 from '/builds/oem/oem-fe-work-manager/src/pages/app-self-support-order/ignore-routes/customer/new-group-msg/model.js';
import ModelModel35 from '/builds/oem/oem-fe-work-manager/src/pages/app-self-support-order/ignore-routes/order-import/model.js';
import ModelModel36 from '/builds/oem/oem-fe-work-manager/src/pages/app-self-support-order/ignore-routes/order-manage/model.js';
import ModelModel37 from '/builds/oem/oem-fe-work-manager/src/pages/app-self-support-order/ignore-routes/setting/model.js';
import ModelModel38 from '/builds/oem/oem-fe-work-manager/src/pages/app-self-support-order/ignore-routes/shop-manage/model.js';
import ModelModel39 from '/builds/oem/oem-fe-work-manager/src/pages/company-management/ignore-routes/base-menu/model.js';
import ModelModel40 from '/builds/oem/oem-fe-work-manager/src/pages/company-management/ignore-routes/management/components/failed-list/model.js';
import ModelModel41 from '/builds/oem/oem-fe-work-manager/src/pages/crm/components/join-group-way-modal/model.js';
import ModelModel42 from '/builds/oem/oem-fe-work-manager/src/pages/crm/components/message-detail/customer/model.js';
import ModelModel43 from '/builds/oem/oem-fe-work-manager/src/pages/crm/components/message-detail/employee/model.js';
import ModelModel44 from '/builds/oem/oem-fe-work-manager/src/pages/crm/components/message-detail/model.js';
import ModelModel45 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/autotask/components/record/components/customer-modal/model.js';
import ModelModel46 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/autotask/components/record/components/employee-modal/model.js';
import ModelModel47 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/autotask/components/record/model.js';
import ModelModel48 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/autotask/components/setting/model.js';
import ModelModel49 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/company-information/model.js';
import ModelModel50 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/company-moments/interaction-ranking/model.js';
import ModelModel51 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/company-moments/moments-params/model.js';
import ModelModel52 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/customer-grouping/model.js';
import ModelModel53 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/customer-management/components/search-transit/components/customization/hz-search/model.js';
import ModelModel54 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/customer-management/components/search-transit/components/customization/main-mc-search/model.js';
import ModelModel55 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/customer-management/components/search-transit/components/customization/mc-search/model.js';
import ModelModel56 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/customer-management/components/search-transit/components/customization/toptoy-search/model.js';
import ModelModel57 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/customer-management/components/search-transit/components/customization/wowcolor-search/model.js';
import ModelModel58 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/customer-warning/model.js';
import ModelModel59 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/drainage-channel-code-manage/components/drainage-code/model.js';
import ModelModel60 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/drainage-channel-manage/components/drainage-channel-manage/model.js';
import ModelModel61 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/drainage-channel-manage/components/fission-channel-manage/components/welcome-message-modal/model.js';
import ModelModel62 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/drainage-channel-manage/components/fission-channel-manage/model.js';
import ModelModel63 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/drainage-channel-stat/components/details/model.js';
import ModelModel64 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/drainage-channel-stat/model.js';
import ModelModel65 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/drainage-contact-me/create/model.js';
import ModelModel66 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/drainage-contact-me/export-material/model.js';
import ModelModel67 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/drainage-contact-me/model.js';
import ModelModel68 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/drainage-welcome-sentence/components/channel-welcome/model.js';
import ModelModel69 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/drainage-welcome-sentence/components/employee-welcome/model.js';
import ModelModel70 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/duplicate-customer/model.js';
import ModelModel71 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/fission/components/customer-fission/model.js';
import ModelModel72 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/fission/components/fission-data/model.js';
import ModelModel73 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/group-bulk/new-group-bulk/model.js';
import ModelModel74 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/group-grouping/model.js';
import ModelModel75 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/group-list/group-member/model.js';
import ModelModel76 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/group-list/model.js';
import ModelModel77 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/group-msg/new-group-msg/model.js';
import ModelModel78 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/group-sop/[id]/model.js';
import ModelModel79 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/group-sop/ignore-routes/model.js';
import ModelModel80 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/group-sop/info/model.js';
import ModelModel81 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/home/model.js';
import ModelModel82 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/material/model.js';
import ModelModel83 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/role-permission/model.js';
import ModelModel84 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/stat-contact-customer/model.js';
import ModelModel85 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/stat-resign/model.js';
import ModelModel86 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/store-management/main-miniso/components/management/components/content/components/community-modal/model.js';
import ModelModel87 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/store-management/main-miniso/components/management/components/content/components/drainage-code-modal/model.js';
import ModelModel88 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/store-management/main-miniso/model.js';
import ModelModel89 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/tag-create-group/components/record/components/associated-customer-group-modal/model.js';
import ModelModel90 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/tag-create-group/create/model.js';
import ModelModel91 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/tag-create-group/model.js';
import ModelModel92 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/task-management/detail/model.js';
import ModelModel93 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/task-management/model.js';
import ModelModel94 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/task-management/task/model.js';
import ModelModel95 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/task-stat-manage/components/staff-stat/model.js';
import ModelModel96 from '/builds/oem/oem-fe-work-manager/src/pages/crm/ignore-routes/team-management/model.js';
import ModelModel97 from '/builds/oem/oem-fe-work-manager/src/pages/message-control/ignore-routes/kpi/config/model.js';
import ModelModel98 from '/builds/oem/oem-fe-work-manager/src/pages/message-control/ignore-routes/kpi/statistic/model.js';
import ModelModel99 from '/builds/oem/oem-fe-work-manager/src/pages/message-control/ignore-routes/message-history/model.js';
import ModelModel100 from '/builds/oem/oem-fe-work-manager/src/pages/message-control/ignore-routes/message-monitor/model.js';
import ModelModel101 from '/builds/oem/oem-fe-work-manager/src/pages/message-control/ignore-routes/sensitive-notification/model.js';
import ModelModel102 from '/builds/oem/oem-fe-work-manager/src/pages/message-control/ignore-routes/sensitive-words/model.js';
import ModelModel103 from '/builds/oem/oem-fe-work-manager/src/pages/message-control/ignore-routes/session-tag/model.js';
import ModelModel104 from '/builds/oem/oem-fe-work-manager/src/pages/message-control/ignore-routes/setting/model.js';

let app:any = null;

export function _onCreate(options = {}) {
  const runtimeDva = plugin.applyPlugins({
    key: 'dva',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    // @ts-ignore
    ...(typeof window !== 'undefined' && window.g_useSSR ? { initialState: window.g_initialProps } : {}),
    ...(options || {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach((plugin:any) => {
    app.use(plugin);
  });
  app.model({ namespace: 'auth', ...ModelAuth0 });
app.model({ namespace: 'base', ...ModelBase1 });
app.model({ namespace: 'channels', ...ModelChannels2 });
app.model({ namespace: 'corp-tags', ...ModelCorpTags3 });
app.model({ namespace: 'departments', ...ModelDepartments4 });
app.model({ namespace: 'group', ...ModelGroup5 });
app.model({ namespace: 'menu', ...ModelMenu6 });
app.model({ namespace: 'public', ...ModelPublic7 });
app.model({ namespace: 'store', ...ModelStore8 });
app.model({ namespace: 'users', ...ModelUsers9 });
app.model({ namespace: 'account', ...ModelAccount10 });
app.model({ namespace: 'company-management', ...ModelCompanyManagement11 });
app.model({ namespace: 'auth', ...ModelAuth12 });
app.model({ namespace: 'base', ...ModelBase13 });
app.model({ namespace: 'programs', ...ModelPrograms14 });
app.model({ namespace: 'create-moment', ...ModelCreateMoment15 });
app.model({ namespace: 'moments', ...ModelMoments16 });
app.model({ namespace: 'post-stat', ...ModelPostStat17 });
app.model({ namespace: 'custom-field', ...ModelCustomField18 });
app.model({ namespace: 'details', ...ModelDetails19 });
app.model({ namespace: 'group-msg', ...ModelGroupMsg20 });
app.model({ namespace: 'details', ...ModelDetails21 });
app.model({ namespace: 'group-msg', ...ModelGroupMsg22 });
app.model({ namespace: 'block', ...ModelBlock23 });
app.model({ namespace: 'delete', ...ModelDelete24 });
app.model({ namespace: 'charts', ...ModelCharts25 });
app.model({ namespace: 'stat', ...ModelStat26 });
app.model({ namespace: 'customer-info', ...ModelCustomerInfo27 });
app.model({ namespace: 'grouping', ...ModelGrouping28 });
app.model({ namespace: 'ming-chuang', ...ModelMingChuang29 });
app.model({ namespace: 'tags', ...ModelTags30 });
app.model({ namespace: 'manage', ...ModelManage31 });
app.model({ namespace: 'record', ...ModelRecord32 });
app.model({ namespace: 'model', ...ModelModel33 });
app.model({ namespace: 'model', ...ModelModel34 });
app.model({ namespace: 'model', ...ModelModel35 });
app.model({ namespace: 'model', ...ModelModel36 });
app.model({ namespace: 'model', ...ModelModel37 });
app.model({ namespace: 'model', ...ModelModel38 });
app.model({ namespace: 'model', ...ModelModel39 });
app.model({ namespace: 'model', ...ModelModel40 });
app.model({ namespace: 'model', ...ModelModel41 });
app.model({ namespace: 'model', ...ModelModel42 });
app.model({ namespace: 'model', ...ModelModel43 });
app.model({ namespace: 'model', ...ModelModel44 });
app.model({ namespace: 'model', ...ModelModel45 });
app.model({ namespace: 'model', ...ModelModel46 });
app.model({ namespace: 'model', ...ModelModel47 });
app.model({ namespace: 'model', ...ModelModel48 });
app.model({ namespace: 'model', ...ModelModel49 });
app.model({ namespace: 'model', ...ModelModel50 });
app.model({ namespace: 'model', ...ModelModel51 });
app.model({ namespace: 'model', ...ModelModel52 });
app.model({ namespace: 'model', ...ModelModel53 });
app.model({ namespace: 'model', ...ModelModel54 });
app.model({ namespace: 'model', ...ModelModel55 });
app.model({ namespace: 'model', ...ModelModel56 });
app.model({ namespace: 'model', ...ModelModel57 });
app.model({ namespace: 'model', ...ModelModel58 });
app.model({ namespace: 'model', ...ModelModel59 });
app.model({ namespace: 'model', ...ModelModel60 });
app.model({ namespace: 'model', ...ModelModel61 });
app.model({ namespace: 'model', ...ModelModel62 });
app.model({ namespace: 'model', ...ModelModel63 });
app.model({ namespace: 'model', ...ModelModel64 });
app.model({ namespace: 'model', ...ModelModel65 });
app.model({ namespace: 'model', ...ModelModel66 });
app.model({ namespace: 'model', ...ModelModel67 });
app.model({ namespace: 'model', ...ModelModel68 });
app.model({ namespace: 'model', ...ModelModel69 });
app.model({ namespace: 'model', ...ModelModel70 });
app.model({ namespace: 'model', ...ModelModel71 });
app.model({ namespace: 'model', ...ModelModel72 });
app.model({ namespace: 'model', ...ModelModel73 });
app.model({ namespace: 'model', ...ModelModel74 });
app.model({ namespace: 'model', ...ModelModel75 });
app.model({ namespace: 'model', ...ModelModel76 });
app.model({ namespace: 'model', ...ModelModel77 });
app.model({ namespace: 'model', ...ModelModel78 });
app.model({ namespace: 'model', ...ModelModel79 });
app.model({ namespace: 'model', ...ModelModel80 });
app.model({ namespace: 'model', ...ModelModel81 });
app.model({ namespace: 'model', ...ModelModel82 });
app.model({ namespace: 'model', ...ModelModel83 });
app.model({ namespace: 'model', ...ModelModel84 });
app.model({ namespace: 'model', ...ModelModel85 });
app.model({ namespace: 'model', ...ModelModel86 });
app.model({ namespace: 'model', ...ModelModel87 });
app.model({ namespace: 'model', ...ModelModel88 });
app.model({ namespace: 'model', ...ModelModel89 });
app.model({ namespace: 'model', ...ModelModel90 });
app.model({ namespace: 'model', ...ModelModel91 });
app.model({ namespace: 'model', ...ModelModel92 });
app.model({ namespace: 'model', ...ModelModel93 });
app.model({ namespace: 'model', ...ModelModel94 });
app.model({ namespace: 'model', ...ModelModel95 });
app.model({ namespace: 'model', ...ModelModel96 });
app.model({ namespace: 'model', ...ModelModel97 });
app.model({ namespace: 'model', ...ModelModel98 });
app.model({ namespace: 'model', ...ModelModel99 });
app.model({ namespace: 'model', ...ModelModel100 });
app.model({ namespace: 'model', ...ModelModel101 });
app.model({ namespace: 'model', ...ModelModel102 });
app.model({ namespace: 'model', ...ModelModel103 });
app.model({ namespace: 'model', ...ModelModel104 });
  return app;
}

export function getApp() {
  return app;
}

/**
 * whether browser env
 * 
 * @returns boolean
 */
function isBrowser(): boolean {
  return typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined'
}

export class _DvaContainer extends Component {
  constructor(props: any) {
    super(props);
    // run only in client, avoid override server _onCreate()
    if (isBrowser()) {
      _onCreate()
    }
  }

  componentWillUnmount() {
    let app = getApp();
    app._models.forEach((model:any) => {
      app.unmodel(model.namespace);
    });
    app._models = [];
    try {
      // 释放 app，for gc
      // immer 场景 app 是 read-only 的，这里 try catch 一下
      app = null;
    } catch(e) {
      console.error(e);
    }
  }

  render() {
    let app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
